import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/computer-device-mobile-tablet.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M176 16H80a24 24 0 0 0-24 24v176a24 24 0 0 0 24 24h96a24 24 0 0 0 24-24V40a24 24 0 0 0-24-24M72 64h112v128H72Zm8-32h96a8 8 0 0 1 8 8v8H72v-8a8 8 0 0 1 8-8m96 192H80a8 8 0 0 1-8-8v-8h112v8a8 8 0 0 1-8 8" }, null, -1)])]);
}
var computer_device_mobile_tablet_default = { render };
//#endregion
export { computer_device_mobile_tablet_default as default, render };

//# sourceMappingURL=computer-device-mobile-tablet.svg.js.map